import { CurrencyService } from "../services/CurrencyService";
import { formatDate, formatMoney } from "../utils/formatters";

export class CurrencyInfo {
  private wrapper: JQuery<HTMLElement>;
  private static readonly LOADING_CLASS = "currency-info-loading";

  constructor() {
    this.wrapper = $('.currency-info-module-wrapper');

    this.update();
  }

  async update() {
    const currency = await CurrencyService.getSelected();

    const data: {[key: string]: string|number|undefined} = {
      '.currency-info-item-price': currency?.sellPrice ? formatMoney(currency?.sellPrice) : undefined,
      '.currency-info-item-volume': `${currency?.volume} ${currency?.code}`,
      '.currency-info-item-variation': `${currency?.variation}%`,
      '.currency-info-item-low': currency?.low ? formatMoney(currency?.low) : undefined,
      '.currency-info-item-high': currency?.high ? formatMoney(currency?.high) : undefined,
      '.currency-info-item-marketcap': currency?.marketcap ? formatMoney(currency?.marketcap) : undefined,
    }

    Object.keys(data).forEach(key => {
      const value = data[key] as string;
      const $value = this.wrapper.find(`${key} .currency-info-value strong`)

      if (!value) {
        $value.closest('.currency-info-item').hide();
      }

      $value.html(value);
    })

    if (currency?.lastUpdateTimestamp) {
      this.wrapper.find('.currency-info-text-update-date').html(formatDate(currency.lastUpdateTimestamp));
    }

    this.wrapper.removeClass(CurrencyInfo.LOADING_CLASS);
  }
}
